import React, { useMemo } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { MeterPointInfo } from "../../../api/meters";
import { Box, Button, Typography } from "@material-ui/core";
import { usePendingMeterReadContext } from "../../../hooks";
import { formatRelative } from "date-fns";
import { DateRangeLabel } from "./DateRangeLabel";
import { CaptionedText } from "./CaptionedText";
import { formatDate } from "../../../utils/formatDate";

interface MeterPointProps extends MeterPointInfo {
  propertyId: string | number;
}
export const MeterPoint: React.FC<MeterPointProps> = ({
  id,
  type,
  identifier,
  propertyId,
  lastMeterReading,
  supplyEndDt,
  supplyStartDt,
}) => {
  const { url } = useRouteMatch();
  const { getReading } = usePendingMeterReadContext();
  const pendingReadDate = getReading(id);

  const readingStatus = useMemo(() => {
    if (pendingReadDate) {
      return `Reading submitted ${formatRelative(
        new Date(pendingReadDate),
        new Date(),
      )}`;
    }
    if (lastMeterReading) {
      return formatDate(lastMeterReading.readingDttm);
    }
    return "No reading available";
  }, [pendingReadDate, lastMeterReading]);

  return (
    <Box display="flex" flexDirection="column" data-testid="MeterPoint">
      <Box>
        <Typography variant="subtitle1">{identifier}</Typography>
      </Box>
      <Box>
        <DateRangeLabel
          title="Supply period"
          from={supplyStartDt}
          to={supplyEndDt}
        />
      </Box>
      <Box mt={2.5}>
        <CaptionedText caption="Last read date" text={readingStatus} />
      </Box>
      <Box mt={2}>
        <Button
          variant="outlined"
          color="primary"
          component={Link}
          to={`${url}/properties/${propertyId}/meterpoints/${id}`}
        >
          Add meter reading
        </Button>
      </Box>
    </Box>
  );
};
